import { Brain, Bot, Zap, TrendingUp, Eye, MessageSquare, BarChart3, Cpu, Network, Layers } from 'lucide-react';

export const aimlCourses = [
    {
        id: 'aiml1',
        title: 'Agentic AI - Building Intelligent Autonomous Systems',
        price: '89999',
        originalPrice: '129999',
        level: 'Advanced',
        duration: '8 Months',
        category: 'aiml',
        lectures: '200+',
        mode: 'Live Online',
        language: 'Hindi/English',
        certificate: "Industry Recognized Certificate",
        tests: "10+",
        assignments: "10+",
        banner: {
            title: 'Agentic AI',
            subtitle: 'Autonomous Systems',
            background: 'bg-gradient-to-r from-cyan-600 to-blue-700',
            Icon: Bot
        },
        description: 'Master the cutting-edge field of Agentic AI and build intelligent systems that can reason, plan, and act autonomously.',
        overview: 'Learn to create AI agents that can perform complex tasks, make decisions, and interact intelligently with users and systems. This course covers the latest in autonomous AI development.',
        highlights: [
            'Most Premium Course',
            'Live & Recorded Classes',
            'Weekly Live Class for Doubt Solving',
            '50+ Assignments',
            'Assessment via Online Test',
            'Practical Approach',
            'Industry Recognised Certification Course',
            'Access to our Placement Portal'
        ],
        curriculum: [
            { 
                title: 'Months 1-2: Agent Fundamentals', 
                topics: [
                    'Introduction to Agentic AI Systems',
                    'Agent Architecture and Design Patterns',
                    'Planning and Reasoning Algorithms',
                    'Goal-Oriented Behavior Modeling'
                ] 
            },
            { 
                title: 'Months 3-4: Advanced Agent Development', 
                topics: [
                    'Multi-Agent Systems and Coordination',
                    'Learning and Adaptation in Agents',
                    'Agent Communication Protocols',
                    'Distributed Agent Architectures'
                ] 
            },
            { 
                title: 'Months 5-6: Integration and Deployment', 
                topics: [
                    'LLM-Powered Agents',
                    'Tool-Using Agents and API Integration',
                    'Agent Memory and Context Management',
                    'Performance Optimization'
                ] 
            },
            { 
                title: 'Months 7-8: Production and Projects', 
                topics: [
                    'Production Deployment of AI Agents',
                    'Monitoring and Maintenance',
                    'Capstone Agent Project',
                    'Future Trends in Agentic AI'
                ] 
            }
        ]
    },
    {
        id: 'aiml2',
        title: 'Machine Learning - Complete Mastery Program',
        price: '79999',
        originalPrice: '119999',
        level: 'Beginner to Advanced',
        duration: '12 Weeks',
        category: 'aiml',
        banner: {
            title: 'Machine Learning',
            subtitle: 'Complete Mastery',
            background: 'bg-gradient-to-r from-green-600 to-emerald-700',
            Icon: Brain
        },
        description: 'Master ML from Basics to Advanced Concepts with Real-World Projects',
        overview: '36 Sessions | 3 Sessions per Week | 2 Hours per Session | Hands-on ML Projects + AI-Driven ML Techniques + Real-World Industry Applications',
        highlights: [
            'Most Premium Course',
            'Live & Recorded Classes',
            'Weekly Live Class for Doubt Solving',
            '50+ Assignments',
            'Assessment via Online Test',
            'Practical Approach',
            'Industry Recognised Certification Course',
            'Access to our Placement Portal'
        ],
        curriculum: [
            { 
                title: '📍 Month 1: Foundations of Machine Learning', 
                topics: [] 
            },
            { 
                title: 'Week 1: Introduction to Machine Learning & AI', 
                topics: [
                    'What is Machine Learning? ML vs. AI vs. Deep Learning',
                    'Types of ML: Supervised, Unsupervised, Reinforcement Learning',
                    'ML Pipeline: Data Collection → Preprocessing → Model Training → Evaluation',
                    'ML Industry Use Cases & Career Paths',
                    'Hands-on Assignment: Setup Python, Jupyter Notebook, Scikit-Learn for ML'
                ] 
            },
            { 
                title: 'Week 2: Data Preprocessing & Feature Engineering', 
                topics: [
                    'Handling Missing Values, Outliers & Duplicates',
                    'Encoding Categorical Data (One-Hot, Label Encoding)',
                    'Feature Scaling (Normalization, Standardization)',
                    'Feature Selection & Dimensionality Reduction (PCA, LDA)',
                    'Hands-on Project: Clean & preprocess a messy dataset for ML model training'
                ] 
            },
            { 
                title: 'Week 3: Exploratory Data Analysis (EDA) & Visualization', 
                topics: [
                    'Pandas & Matplotlib for EDA',
                    'Data Distribution Analysis & Statistical Insights',
                    'Correlation Analysis & Hypothesis Testing',
                    'Data Visualization Best Practices',
                    'Hands-on Project: Perform EDA on a real-world dataset (e.g., Customer Churn, Sales Data)'
                ] 
            },
            { 
                title: 'Week 4: Supervised Learning - Regression Models', 
                topics: [
                    'Linear Regression: Basics, Cost Function & Optimization',
                    'Multiple Regression & Polynomial Regression',
                    'Ridge, Lasso, & ElasticNet for Regularization',
                    'Model Performance Metrics (R², RMSE, MAE)',
                    'Hands-on Project: Build a House Price Prediction Model using Linear Regression'
                ] 
            },
            { 
                title: '📍 Month 2: Supervised & Unsupervised Learning + Advanced ML', 
                topics: [] 
            },
            { 
                title: 'Week 5: Supervised Learning - Classification Models', 
                topics: [
                    'Logistic Regression for Binary Classification',
                    'Decision Trees & Random Forest',
                    'Support Vector Machines (SVM)',
                    'Model Evaluation Metrics (Precision, Recall, F1-Score, AUC-ROC)',
                    'Hands-on Project: Build a Spam Email Classifier using Logistic Regression'
                ] 
            },
            { 
                title: 'Week 6: Ensemble Learning & Hyperparameter Tuning', 
                topics: [
                    'Bagging & Boosting (Random Forest, XGBoost, AdaBoost)',
                    'Hyperparameter Tuning (GridSearchCV, RandomizedSearchCV)',
                    'Handling Imbalanced Data (SMOTE, Undersampling)',
                    'Cross-Validation & Bias-Variance Tradeoff',
                    'Hands-on Project: Develop a Fraud Detection Model using XGBoost'
                ] 
            },
            { 
                title: 'Week 7: Unsupervised Learning - Clustering & Anomaly Detection', 
                topics: [
                    'K-Means Clustering & Elbow Method',
                    'DBSCAN & Hierarchical Clustering',
                    'Anomaly Detection (Isolation Forest, LOF)',
                    'Applications: Customer Segmentation, Outlier Detection',
                    'Hands-on Project: Perform Customer Segmentation for a Retail Business'
                ] 
            },
            { 
                title: 'Week 8: Recommendation Systems & Reinforcement Learning', 
                topics: [
                    'Collaborative Filtering & Content-Based Recommendation',
                    'Matrix Factorization (SVD, NMF)',
                    'Reinforcement Learning Basics & Applications in AI',
                    'Bandit Algorithms & Policy Optimization',
                    'Hands-on Project: Build a Movie Recommendation System'
                ] 
            },
            { 
                title: '📍 Month 3: AI-Powered ML, Deep Learning & Deployment', 
                topics: [] 
            },
            { 
                title: 'Week 9: Introduction to Deep Learning with TensorFlow & Keras', 
                topics: [
                    'Neural Networks: Basics of Perceptron & Backpropagation',
                    'Deep Learning Architectures (CNNs, RNNs, GANs)',
                    'AI-Powered ML: Transfer Learning & Pretrained Models',
                    'Implementing a Simple Neural Network',
                    'Hands-on Project: Train a Digit Recognition Model using Neural Networks'
                ] 
            },
            { 
                title: 'Week 10: Natural Language Processing (NLP) & Time-Series Analysis', 
                topics: [
                    'Text Preprocessing (Tokenization, Stemming, Lemmatization)',
                    'Sentiment Analysis using NLP (TF-IDF, Word2Vec, Transformers)',
                    'Time-Series Forecasting (ARIMA, LSTMs)',
                    'AI in NLP: Chatbots & LLMs',
                    'Hands-on Project: Build a Sentiment Analysis Model for Customer Reviews'
                ] 
            },
            { 
                title: 'Week 11: Machine Learning Deployment & MLOps', 
                topics: [
                    'Model Deployment using Flask, FastAPI & Streamlit',
                    'CI/CD Pipelines for ML Model Deployment',
                    'Docker & Kubernetes for Scalable AI Solutions',
                    'Monitoring & Maintaining ML Models',
                    'Hands-on Project: Deploy an ML Model as an API for real-world use'
                ] 
            },
            { 
                title: 'Week 12: Industry Applications & Capstone Project', 
                topics: [
                    'AI in Healthcare, Finance, Marketing, & Cybersecurity',
                    'AI Ethics & Bias Mitigation Strategies',
                    'Resume & Portfolio Building for ML Roles',
                    'Capstone Project Presentation',
                    'Final Capstone Project: End-to-End AI-Powered ML Solution for Business or Research'
                ] 
            }
        ],
        skillsCovered: 'Machine Learning Algorithms, Deep Learning, NLP, Time Series Analysis, MLOps, AI-Powered ML, Model Deployment',
        toolsCovered: 'Python, Scikit-Learn, TensorFlow, Keras, Pandas, NumPy, Flask, FastAPI, Docker, Git',
        certification: 'Training Certification on Successful Completion of the Course',
        jobOutcomes: [
            '10+ Hands-on ML Projects for Resume & Portfolio',
            'Industry-Ready ML Model Deployment & MLOps Skills',
            'Capstone Project for Job Readiness & Interviews',
            'AI-Powered Machine Learning Applications'
        ],
        targetAudience: [
            'College students aiming for Machine Learning & AI careers',
            'Professionals looking to transition into ML roles',
            'Entrepreneurs & Researchers exploring ML Applications'
        ]
    },
    {
        id: 'aiml3',
        title: 'Prompt Engineering - Mastering AI Communication',
        price: '49999',
        originalPrice: '79999',
        level: 'Intermediate',
        duration: '3 Months',
        category: 'aiml',
        banner: {
            title: 'Prompt Engineering',
            subtitle: 'AI Communication',
            background: 'bg-gradient-to-r from-purple-600 to-violet-700',
            Icon: MessageSquare
        },
        description: 'Master Prompt Engineering for AI & Large Language Models (LLMs)',
        overview: 'This comprehensive Prompt Engineering course teaches you how to effectively communicate with AI systems and large language models. Learn advanced prompting techniques, from basic prompting to complex chain-of-thought reasoning, to get the most out of AI tools and automate workflows.',
        highlights: [
            'Most Premium Course',
            'Live & Recorded Classes',
            'Weekly Live Class for Doubt Solving',
            '50+ Assignments',
            'Assessment via Online Test',
            'Practical Approach',
            'Industry Recognised Certification Course',
            'Access to our Placement Portal'
        ],
        whyOSOP: [
            'India\'s Most Premium Coding Class',
            '26+ Years of Technology Training',
            'Zero Error Programming',
            'Strong Conceptual & Practical Knowledge'
        ],
        curriculum: [
            { 
                title: 'Week 1: Introduction to Prompt Engineering & AI Models', 
                topics: [
                    'What is Prompt Engineering?',
                    'How Large Language Models (LLMs) Work (GPT-4, Claude, Gemini, LLaMA)',
                    'Tokens, Context Windows & Model Behavior',
                    'Prompt Engineering for AI-Driven Applications'
                ] 
            },
            { 
                title: 'Week 2: Fundamentals of Effective Prompt Writing', 
                topics: [
                    'Direct & Indirect Prompts',
                    'Zero-Shot, Few-Shot, & Chain-of-Thought (CoT) Prompting',
                    'Role-Playing & Instruction-Based Prompting',
                    'Understanding AI Model Bias & Ethical Prompting'
                ] 
            },
            { 
                title: 'Week 3: Advanced Prompting Techniques', 
                topics: [
                    'Contextual Memory & Long-Form Prompting',
                    'Using Examples & Demos for Better Responses',
                    'Refining Prompts with Iterative Testing',
                    'Temperature & Top-K Sampling for Output Control'
                ] 
            },
            { 
                title: 'Week 4: AI for Text Generation & Summarization', 
                topics: [
                    'AI-Powered Text Summarization (Extractive vs. Abstractive)',
                    'AI for Content Writing & Creative Storytelling',
                    'Rewriting & Paraphrasing with AI',
                    'AI for Research & Technical Writing'
                ] 
            },
            { 
                title: 'Week 5: AI for Business & Marketing Prompting', 
                topics: [
                    'AI for SEO & Blog Content Optimization',
                    'AI-Generated Marketing Ad Copy & Campaigns',
                    'AI-Powered Email Writing & Customer Engagement',
                    'AI for Product Descriptions & Sales Copy'
                ] 
            },
            { 
                title: 'Week 6: AI for Code Generation & Software Development', 
                topics: [
                    'Prompting for AI Code Assistants (GitHub Copilot, Codeium, Tabnine)',
                    'Debugging & Code Refactoring with AI',
                    'AI for API Documentation & Technical Writing',
                    'Automating Software Testing with AI'
                ] 
            },
            { 
                title: 'Week 7: AI for Data Analysis & Visualization', 
                topics: [
                    'Using Prompting for AI-Powered Data Insights',
                    'Generating SQL Queries with AI',
                    'Automating Report Writing & Business Dashboards',
                    'AI-Driven Financial & Market Analysis'
                ] 
            },
            { 
                title: 'Week 8: AI for Images, Videos & Creative Work', 
                topics: [
                    'AI Image Generation with DALL-E, MidJourney, Leonardo AI',
                    'AI-Powered Video Generation & Editing (RunwayML, Pictory AI)',
                    'AI for Graphic Design & Presentations (Canva AI, Tome AI)',
                    'AI for Logo, Branding & Visual Content'
                ] 
            },
            { 
                title: 'Week 9: AI for Automation & No-Code AI Development', 
                topics: [
                    'AI for Workflow Automation (Zapier AI, Make AI)',
                    'AI-Driven Chatbots & Virtual Assistants',
                    'AI for Business Process Automation',
                    'AI-Powered Document Processing'
                ] 
            },
            { 
                title: 'Week 10: RAG (Retrieval-Augmented Generation) & AI Search', 
                topics: [
                    'Introduction to RAG & Contextual Search',
                    'Using Vector Databases (FAISS, Pinecone)',
                    'AI-Powered Document Q&A Systems',
                    'Building an AI-Powered Search Engine'
                ] 
            },
            { 
                title: 'Week 11: AI Agents & Autonomous Prompting', 
                topics: [
                    'Introduction to AutoGPT, BabyAGI & CrewAI',
                    'Multi-Step Prompts for Autonomous AI',
                    'AI Planning & Task Automation with Prompts',
                    'Ethical Considerations in AI Agents'
                ] 
            },
            { 
                title: 'Week 12: Capstone Project & Career Preparation', 
                topics: [
                    'Resume Optimization for AI & Prompt Engineering Roles',
                    'Portfolio Building & AI Project Deployment',
                    'Prompt Engineering Interview Questions & Mock Interviews',
                    'Final Capstone Project Presentation'
                ] 
            }
        ],
        skillsCovered: 'Advanced Prompt Engineering, AI Communication, Chain-of-Thought Prompting, RAG, AI Agents, AI Automation',
        toolsCovered: 'ChatGPT, Claude, Gemini, LLaMA, DALL-E, MidJourney, GitHub Copilot, Codeium, Zapier AI, Vector Databases',
        certification: 'Training Certification on Successful Completion of the Course',
        jobOutcomes: [
            '10+ Hands-on Prompt Engineering Projects',
            'AI Workflow Automation & AI-Driven Business Use Cases',
            'RAG, AI Agents, & No-Code AI Development',
            'Capstone Project for Job Readiness'
        ],
        targetAudience: [
            'AI Enthusiasts, Content Creators, Business Professionals',
            'Developers & Data Scientists exploring Prompt Engineering',
            'Entrepreneurs & Marketers leveraging AI for Productivity'
        ]
    },
    {
        id: 'aiml4',
        title: 'MLOps - Machine Learning Operations and Deployment',
        price: '69999',
        originalPrice: '99999',
        level: 'Intermediate to Advanced',
        duration: '6 Months',
        category: 'aiml',
        banner: {
            title: 'MLOps',
            subtitle: 'ML Operations',
            background: 'bg-gradient-to-r from-orange-600 to-red-700',
            Icon: Cpu
        },
        description: 'Learn to deploy, monitor, and maintain machine learning models in production environments.',
        overview: 'Master the complete MLOps lifecycle from model development to production deployment. Learn industry best practices for scalable ML systems.',
        highlights: [
            'Most Premium Course',
            'Live & Recorded Classes',
            'Weekly Live Class for Doubt Solving',
            '50+ Assignments',
            'Assessment via Online Test',
            'Practical Approach',
            'Industry Recognised Certification Course',
            'Access to our Placement Portal'
        ],
        curriculum: [
            { 
                title: 'Months 1-2: MLOps Fundamentals', 
                topics: [
                    'Introduction to MLOps',
                    'ML Lifecycle Management',
                    'Version Control for ML',
                    'Data Pipeline Development'
                ] 
            },
            { 
                title: 'Months 3-4: Deployment and Automation', 
                topics: [
                    'Model Deployment Strategies',
                    'CI/CD for Machine Learning',
                    'Containerization with Docker',
                    'Kubernetes for ML Workloads'
                ] 
            },
            { 
                title: 'Months 5-6: Monitoring and Scaling', 
                topics: [
                    'Model Monitoring and Observability',
                    'Performance Tracking and Alerting',
                    'Model Drift Detection',
                    'Scaling ML Systems'
                ] 
            }
        ]
    },
    {
        id: 'aiml5',
        title: 'AI Product Management - Strategic AI Leadership',
        price: '79999',
        originalPrice: '119999',
        level: 'Intermediate',
        duration: '3 Months',
        category: 'aiml',
        banner: {
            title: 'AI Product',
            subtitle: 'Management',
            background: 'bg-gradient-to-r from-indigo-600 to-purple-700',
            Icon: TrendingUp
        },
        description: 'Master AI-Driven Product Development, Strategy & Deployment',
        overview: 'This comprehensive AI Product Management course bridges the gap between technical AI capabilities and business strategy. Learn to manage AI products from conception to launch with strategic thinking, technical understanding, and business acumen. The course covers AI fundamentals, product strategy, and leadership skills needed to drive successful AI initiatives.',
        highlights: [
            'Most Premium Course',
            'Live & Recorded Classes',
            'Weekly Live Class for Doubt Solving',
            '50+ Assignments',
            'Assessment via Online Test',
            'Practical Approach',
            'Industry Recognised Certification Course',
            'Access to our Placement Portal'
        ],
        whyOSOP: [
            'India\'s Most Premium Coding Class',
            '26+ Years of Technology Training',
            'Zero Error Programming',
            'Strong Conceptual & Practical Knowledge'
        ],
        curriculum: [
            { 
                title: 'Week 1: Introduction to AI Product Management', 
                topics: [
                    'What is AI Product Management?',
                    'Difference Between Traditional & AI-Driven Product Management',
                    'AI Business Strategy & Market Opportunities',
                    'Understanding the AI Development Lifecycle'
                ] 
            },
            { 
                title: 'Week 2: Understanding AI & Machine Learning Basics for PMs', 
                topics: [
                    'AI vs. ML vs. Deep Learning',
                    'Types of Machine Learning (Supervised, Unsupervised, Reinforcement)',
                    'AI Model Lifecycle (Data, Model Training, Deployment, Monitoring)',
                    'No-Code AI Tools for Product Managers'
                ] 
            },
            { 
                title: 'Week 3: Data-Driven AI Product Management', 
                topics: [
                    'Importance of Data in AI Products',
                    'Data Collection, Cleaning, & Feature Engineering Basics',
                    'Data Strategy & Governance for AI Products',
                    'Understanding Bias & Fairness in AI'
                ] 
            },
            { 
                title: 'Week 4: AI Product Roadmaps & Agile Development', 
                topics: [
                    'How AI Impacts Agile Product Development',
                    'Defining AI Product Roadmaps & MVP Development',
                    'Cross-functional Collaboration (Engineering, Data Science, UX)',
                    'Lean AI Product Development Approach'
                ] 
            },
            { 
                title: 'Week 5: AI Use Cases & Market Research', 
                topics: [
                    'Identifying AI Product Opportunities in Various Industries',
                    'Competitive Analysis of AI Products',
                    'AI Business Models (SaaS, API Monetization, Enterprise AI)',
                    'Customer Persona Mapping for AI Adoption'
                ] 
            },
            { 
                title: 'Week 6: Designing AI-Powered User Experiences', 
                topics: [
                    'AI & UX: Designing AI Interactions',
                    'Human-Centered AI Design & Ethical AI Principles',
                    'AI Explainability & Trust in AI Products',
                    'Prototyping AI Interfaces (Figma, No-Code AI Tools)'
                ] 
            },
            { 
                title: 'Week 7: AI Product Monetization & Go-To-Market Strategy', 
                topics: [
                    'Business Models for AI Products',
                    'AI API Monetization & Subscription Pricing Models',
                    'AI Product Positioning & Market Entry Strategies',
                    'AI-Powered Growth Hacking & User Retention'
                ] 
            },
            { 
                title: 'Week 8: Managing AI Product Risks & Compliance', 
                topics: [
                    'Ethical Considerations & AI Regulations (GDPR, CCPA, AI Act)',
                    'AI Model Interpretability & Transparency',
                    'Security & Privacy Challenges in AI Products',
                    'Risk Mitigation in AI-Powered Decision-Making'
                ] 
            },
            { 
                title: 'Week 9: AI Product Deployment & Scaling', 
                topics: [
                    'Basics of AI Deployment (Cloud AI, APIs, Edge AI)',
                    'Managing AI Models in Production',
                    'Continuous Model Improvement & Model Drift Detection',
                    'AI Product Performance Metrics & KPIs'
                ] 
            },
            { 
                title: 'Week 10: AI in Business & Enterprise Adoption', 
                topics: [
                    'AI in Healthcare, Finance, E-Commerce & Other Industries',
                    'Enterprise AI Adoption Challenges & Solutions',
                    'AI Integration with Existing Business Systems',
                    'ROI Analysis for AI Product Investments'
                ] 
            },
            { 
                title: 'Week 11: AI Product Leadership & Cross-Team Collaboration', 
                topics: [
                    'Working with AI Engineers, Data Scientists & Stakeholders',
                    'AI Product Ownership vs. Engineering Leadership',
                    'Aligning AI Product Goals with Business Strategy',
                    'Communicating AI Product Value to Executives'
                ] 
            },
            { 
                title: 'Week 12: Capstone Project & Career Preparation', 
                topics: [
                    'Resume Optimization for AI PM Roles',
                    'AI Product Management Case Studies & Mock Interviews',
                    'Building a Portfolio with AI Product Roadmaps',
                    'Final Capstone Project Presentation'
                ] 
            }
        ],
        skillsCovered: 'AI Product Strategy, AI Roadmap Planning, GTM Execution, AI Monetization, Business AI Integration',
        toolsCovered: 'Figma, No-Code AI Tools, Product Management Software, AI Prototyping Tools',
        certification: 'Training Certification on Successful Completion of the Course',
        jobOutcomes: [
            '10+ AI Product Management Projects for Resume & Portfolio',
            'AI Business Strategy, Monetization & GTM Planning',
            'AI Product Lifecycle Management & Deployment',
            'Capstone Project for Job Readiness'
        ],
        targetAudience: [
            'Product Managers & Business Leaders entering AI Product Management',
            'Entrepreneurs & Founders wanting to build AI-powered products',
            'Engineers & Data Scientists transitioning to AI PM roles'
        ]
    },
    {
        id: 'aiml6',
        title: 'AI-Powered Business Analysis - Data-Driven Insights',
        price: '59999',
        originalPrice: '89999',
        level: 'Intermediate',
        duration: '3 Months',
        category: 'aiml',
        banner: {
            title: 'AI Business',
            subtitle: 'Analysis',
            background: 'bg-gradient-to-r from-teal-600 to-cyan-700',
            Icon: BarChart3
        },
        description: 'Master AI-Driven Insights, Automation & Decision-Making for Business Analysts',
        overview: 'This comprehensive AI-Powered Business Analysis course teaches you how to leverage artificial intelligence for business intelligence, process automation, and strategic decision-making. Learn to transform traditional business analysis with cutting-edge AI tools and techniques for enhanced productivity and data-driven insights.',
        highlights: [
            'Hands-on AI Projects',
            'Business Analytics Automation',
            'AI-Powered Decision-Making',
            '12 Weeks Intensive Training',
            '3 Sessions per Week | 2 Hours per Session',
            '10+ AI Business Analysis Projects'
        ],
        whyOSOP: [
            'India\'s Most Premium Coding Class',
            '26+ Years of Technology Training',
            'Zero Error Programming',
            'Strong Conceptual & Practical Knowledge'
        ],
        curriculum: [
            { 
                title: 'Week 1: Introduction to AI in Business Analysis', 
                topics: [
                    'Role of AI in Business Analysis & Decision-Making',
                    'AI vs. Traditional Business Analysis Approaches',
                    'How AI Enhances Data-Driven Insights & Automation',
                    'Overview of AI Tools for Business Analysts (ChatGPT, Perplexity AI, Tableau AI, Power BI AI)'
                ] 
            },
            { 
                title: 'Week 2: AI for Data Collection, Cleaning & Preprocessing', 
                topics: [
                    'AI for Data Wrangling & Cleaning (OpenRefine, Trifacta, SheetAI)',
                    'Automating Data Extraction with AI (Web Scraping & API Calls)',
                    'AI for Handling Missing Data & Outlier Detection',
                    'AI-Powered Data Labeling & Classification'
                ] 
            },
            { 
                title: 'Week 3: AI-Powered Data Analysis & Visualization', 
                topics: [
                    'Using AI in BI Tools (Tableau AI, Power BI AI, Looker Studio AI)',
                    'AI-Driven Data Exploration & Automated Insights',
                    'AI-Powered Trend Analysis & Forecasting',
                    'Automated Business Reporting with AI'
                ] 
            },
            { 
                title: 'Week 4: AI for Business Forecasting & Predictive Analytics', 
                topics: [
                    'Introduction to AI in Forecasting (Regression, Time Series Analysis)',
                    'AI-Powered Sales & Demand Forecasting',
                    'Using AutoML for Predictive Analytics (H2O.ai, Google AutoML)',
                    'AI in Market & Consumer Behavior Prediction'
                ] 
            },
            { 
                title: 'Week 5: AI for Competitive Intelligence & Market Research', 
                topics: [
                    'AI Tools for Market Analysis (Crayon AI, Perplexity AI, ChatGPT)',
                    'AI-Generated Competitor Analysis Reports',
                    'AI-Powered SWOT Analysis for Business Strategy',
                    'AI for Consumer Sentiment Analysis'
                ] 
            },
            { 
                title: 'Week 6: AI for Business Process Automation (BPA)', 
                topics: [
                    'Introduction to AI-Driven BPA & Workflow Automation',
                    'AI for Automating Repetitive Business Tasks (Zapier AI, Make.com, n8n)',
                    'AI-Powered Document Processing & Report Generation',
                    'AI in Customer Support & Service Automation'
                ] 
            },
            { 
                title: 'Week 7: AI for Business Decision-Making & Risk Analysis', 
                topics: [
                    'AI-Powered Decision Support Systems',
                    'AI for Risk Identification & Fraud Detection',
                    'AI in Financial Analysis & Credit Scoring',
                    'Ethical Considerations in AI-Powered Decision-Making'
                ] 
            },
            { 
                title: 'Week 8: AI-Powered Text & Sentiment Analysis for Business', 
                topics: [
                    'Using AI to Analyze Customer Reviews & Social Media Sentiment',
                    'AI for Automated Report Summarization & Text Mining',
                    'AI in Customer Support Automation & NPS Prediction',
                    'AI-Powered Chatbots for Business Intelligence'
                ] 
            },
            { 
                title: 'Week 9: AI for Business Strategy & Financial Analysis', 
                topics: [
                    'AI-Powered Strategic Planning & Business Modeling',
                    'AI in Financial Statement Analysis & Forecasting',
                    'AI for Cost Optimization & Profitability Analysis',
                    'AI for Investment Decision-Making'
                ] 
            },
            { 
                title: 'Week 10: AI for Business Process Improvement & Optimization', 
                topics: [
                    'AI-Driven Process Mining & Workflow Optimization',
                    'AI in Supply Chain & Logistics Optimization',
                    'AI for Operations Management & Cost Reduction',
                    'AI in HR Analytics & Employee Productivity'
                ] 
            },
            { 
                title: 'Week 11: AI for Business Presentations & Storytelling', 
                topics: [
                    'AI for Data-Driven Decision-Making & Storytelling',
                    'AI-Powered Slide & Document Generation (Tome AI, Notion AI, Canva AI)',
                    'Automating Business Reporting & Presentation with AI',
                    'AI-Powered Stakeholder Communication'
                ] 
            },
            { 
                title: 'Week 12: Capstone Project & Career Preparation', 
                topics: [
                    'Resume & LinkedIn Optimization for AI-Powered Business Analyst Roles',
                    'Building a Portfolio with AI-Driven Business Insights',
                    'Mock Interviews & AI in Business Case Studies',
                    'Final Capstone Project Presentation'
                ] 
            }
        ],
        skillsCovered: 'AI-Powered Data Analysis, Business Intelligence, Decision Support Systems, Process Automation, AI in Finance',
        toolsCovered: 'ChatGPT, Perplexity AI, Tableau AI, Power BI AI, H2O.ai, Google AutoML, Zapier AI, Make.com, Tome AI, Notion AI, Canva AI',
        certification: 'Training Certification on Successful Completion of the Course',
        jobOutcomes: [
            '10+ AI-Powered Business Analysis Projects for Resume & Portfolio',
            'Automated Business Insights & AI Decision-Making Models',
            'AI-Powered Dashboards, Forecasting & Market Research Tools',
            'Capstone Project for Job Readiness'
        ],
        targetAudience: [
            'Business Analysts, Consultants & Managers exploring AI for Business',
            'Product & Strategy Professionals looking to leverage AI for decision-making',
            'Entrepreneurs & Business Leaders integrating AI-powered automation & insights'
        ]
    },
    {
        id: 'aiml7',
        title: 'AI Tools Mastery - Complete AI Toolkit',
        price: '39999',
        originalPrice: '69999',
        level: 'Beginner to Advanced',
        duration: '3 Months',
        category: 'aiml',
        banner: {
            title: 'AI Tools',
            subtitle: 'Mastery',
            background: 'bg-gradient-to-r from-yellow-600 to-orange-600',
            Icon: Zap
        },
        description: 'Learn 40+ AI Tools to Supercharge Productivity, Content Creation & Business Growth',
        overview: 'This comprehensive AI Tools Mastery course is designed specifically for non-technical professionals. Learn to leverage the power of 40+ AI tools to enhance productivity, create engaging content, and drive business growth without needing coding skills.',
        highlights: [
            '40+ AI Tools Covered',
            'Hands-on Practical Learning',
            'Real-World Use Cases',
            '12 Weeks Intensive Training',
            '3 Sessions per Week | 2 Hours per Session'
        ],
        whyOSOP: [
            'India\'s Most Premium Coding Class',
            '26+ Years of Technology Training',
            'Zero Error Programming',
            'Strong Conceptual & Practical Knowledge'
        ],
        curriculum: [
            { 
                title: 'Week 1: AI for Personal Productivity & Smart Workflows', 
                topics: [
                    'ChatGPT, Claude AI, Perplexity AI – AI-assisted research & writing',
                    'Fireflies AI, Motion AI – AI-powered meeting transcription & scheduling',
                    'Zapier AI – AI-powered task automation',
                    'Hands-on Project: Automate meeting notes & summaries using Fireflies AI & ChatGPT'
                ] 
            },
            { 
                title: 'Week 2: AI for Writing, Emails & Presentations', 
                topics: [
                    'Grammarly AI, Jasper AI, Copy.ai – AI-assisted email & content writing',
                    'Notion AI, Tome AI – AI-powered document & presentation creation',
                    'Hands-on Project: Create an AI-generated business proposal & presentation'
                ] 
            },
            { 
                title: 'Week 3: AI for Business Automation & CRM', 
                topics: [
                    'HubSpot AI, Tidio AI – AI-powered customer engagement & chatbots',
                    'AdCreative AI – AI-powered ad content generation',
                    'Hands-on Project: Automate customer support responses using AI'
                ] 
            },
            { 
                title: 'Week 4: AI for Research & Data Analysis', 
                topics: [
                    'ChatGPT Advanced Data Analysis – AI-powered Excel & Sheets insights',
                    'Looker Studio AI – AI-powered BI dashboards',
                    'Hands-on Project: Automate market research & competitor analysis using AI'
                ] 
            },
            { 
                title: 'Week 5: AI for Video Editing & Creation', 
                topics: [
                    'Runway ML, Pictory AI, Synthesia AI – AI-generated videos',
                    'Descript – AI-powered podcast & video editing',
                    'Hands-on Project: Create an AI-generated video ad for a product'
                ] 
            },
            { 
                title: 'Week 6: AI for Image & Graphic Design', 
                topics: [
                    'DALL-E, MidJourney, Leonardo AI – AI-generated art & graphics',
                    'Canva AI – AI-powered social media graphics',
                    'Hands-on Project: Create AI-generated Instagram posts & banners'
                ] 
            },
            { 
                title: 'Week 7: AI for Music & Voice Generation', 
                topics: [
                    'Suno AI, ElevenLabs AI – AI-generated voiceovers & music',
                    'Murf AI – AI-powered audiobook voice creation',
                    'Hands-on Project: Generate an AI voiceover & background music for a YouTube video'
                ] 
            },
            { 
                title: 'Week 8: AI for SEO & Marketing Optimization', 
                topics: [
                    'Surfer SEO, Writesonic – AI-powered SEO content optimization',
                    'AdCreative AI – AI-generated ad copy & creatives',
                    'Hands-on Project: Create AI-optimized blog content & ads'
                ] 
            },
            { 
                title: 'Week 9: AI for E-Commerce & Sales Optimization', 
                topics: [
                    'Tidio AI – AI-powered chatbots for customer service',
                    'AdCreative AI – AI-powered product ad generation',
                    'Hands-on Project: Set up an AI chatbot for an online store'
                ] 
            },
            { 
                title: 'Week 10: AI for Advanced Research & Data Insights', 
                topics: [
                    'Perplexity AI Pro, ChatGPT Data Analysis – AI-powered deep research',
                    'SheetAI – AI automation for data processing',
                    'Hands-on Project: Automate a business report with AI-generated insights'
                ] 
            },
            { 
                title: 'Week 11: AI for No-Code & Low-Code Development', 
                topics: [
                    'Bubble.io, Zapier AI – No-code AI app development',
                    'Codeium, GitHub Copilot – AI-powered coding assistants',
                    'Hands-on Project: Build a no-code AI-powered app using Zapier'
                ] 
            },
            { 
                title: 'Week 12: AI for Freelancing & Job Market Readiness', 
                topics: [
                    'How to monetize AI skills (Freelancing, Consulting, Startups)',
                    'Ethical AI & Responsible AI Usage',
                    'Final Capstone Project Presentation',
                    'Hands-on Project: Build an AI-powered content, marketing, or productivity system'
                ] 
            }
        ],
        skillsCovered: 'AI-Powered Content Creation, Business Automation, Productivity Enhancement, Marketing Optimization, No-Code Development',
        toolsCovered: 'ChatGPT, Claude AI, Perplexity AI, Notion AI, Tome AI, Grammarly AI, Fireflies AI, Motion AI, Zapier AI, Runway ML, Descript, Pictory AI, Synthesia AI, HeyGen AI, DeepBrain AI, DALL-E, MidJourney, Leonardo AI, Canva AI, Jasper AI, Copy.ai, Writesonic, Rytr AI, Suno AI, ElevenLabs AI, Murf AI, AdCreative AI, HubSpot AI, Surfer SEO, Tidio AI, GitHub Copilot, Codeium, Looker Studio AI, SheetAI',
        certification: 'Training Certification on Successful Completion of the Course',
        jobOutcomes: [
            'Practical Hands-on Learning with 40+ AI Tools',
            'Build a Portfolio of AI-Powered Projects',
            'AI for Business, Marketing, & Productivity Skills',
            'Capstone Project for Job Readiness'
        ],
        targetAudience: [
            'Business professionals, entrepreneurs, freelancers',
            'Marketers, content creators, & social media managers',
            'Non-tech professionals looking to leverage AI for efficiency'
        ]
    },
    {
        id: 'aiml8',
        title: 'Natural Language Processing (NLP) - Language AI Mastery',
        price: '74999',
        originalPrice: '109999',
        level: 'Intermediate to Advanced',
        duration: '7 Months',
        category: 'aiml',
        banner: {
            title: 'NLP',
            subtitle: 'Language AI',
            background: 'bg-gradient-to-r from-pink-600 to-rose-700',
            Icon: MessageSquare
        },
        description: 'Master Natural Language Processing and build sophisticated language AI applications.',
        overview: 'Comprehensive NLP program covering text processing, language models, and advanced NLP applications. Build chatbots, analyzers, and language AI systems.',
        highlights: [
            'Complete NLP pipeline development',
            'Transformer models and BERT',
            'Sentiment analysis and classification',
            'Named entity recognition',
            'Language model fine-tuning',
            'Conversational AI development'
        ],
        curriculum: [
            { 
                title: 'Months 1-2: NLP Fundamentals', 
                topics: [
                    'Text Preprocessing and Tokenization',
                    'Regular Expressions and Pattern Matching',
                    'Statistical NLP Methods',
                    'Word Embeddings (Word2Vec, GloVe)'
                ] 
            },
            { 
                title: 'Months 3-4: Advanced NLP', 
                topics: [
                    'Recurrent Neural Networks for NLP',
                    'Attention Mechanisms',
                    'Transformer Architecture',
                    'BERT and GPT Models'
                ] 
            },
            { 
                title: 'Months 5-6: NLP Applications', 
                topics: [
                    'Sentiment Analysis and Opinion Mining',
                    'Named Entity Recognition',
                    'Question Answering Systems',
                    'Text Summarization'
                ] 
            },
            { 
                title: 'Month 7: Advanced Projects', 
                topics: [
                    'Conversational AI and Chatbots',
                    'Language Model Fine-tuning',
                    'Multilingual NLP',
                    'NLP Capstone Project'
                ] 
            }
        ]
    },
    {
        id: 'aiml9',
        title: 'Data Analytics and Data Visualization - AI-Enhanced Insights',
        price: '54999',
        originalPrice: '84999',
        level: 'Beginner to Intermediate',
        duration: '12 Weeks',
        category: 'aiml',
        banner: {
            title: 'Data Analytics',
            subtitle: 'AI Visualization',
            background: 'bg-gradient-to-r from-blue-600 to-indigo-700',
            Icon: BarChart3
        },
        description: 'Master data analytics and visualization with AI-powered tools and techniques for actionable insights.',
        overview: '36 Sessions | 3 Sessions per Week | 2 Hours per Session | Hands-on Projects + Business Use Cases + AI-Driven Analytics',
        highlights: [
            'Most Premium Course',
            'Live & Recorded Classes',
            'Weekly Live Class for Doubt Solving',
            '50+ Assignments',
            'Assessment via Online Test',
            'Practical Approach',
            'Industry Recognised Certification Course',
            'Access to our Placement Portal'
        ],
        whyOSOP: [
            'India\'s most premium coding class',
            '26+ Years of Technology Training',
            'Zero Error Programming',
            'Strong Conceptual & Practical Knowledge'
        ],
        curriculum: [
            { 
                title: '📍 Month 1: Foundations of Data Analytics & Excel for Analysis', 
                topics: [] 
            },
            { 
                title: 'Week 1: Introduction to Data Analytics & Business Intelligence', 
                topics: [
                    'Understanding Data Analytics & BI',
                    'Data Analytics vs. Data Science vs. AI',
                    'Data Analytics Process (ETL, Data Cleaning, Analysis, Insights)',
                    'Introduction to SQL, Excel, and Python for Data Analytics',
                    'Hands-on Assignment: Extract & clean a real dataset (e.g., sales, customer data)'
                ] 
            },
            { 
                title: 'Week 2: Excel for Data Analytics & Dashboards', 
                topics: [
                    'Advanced Excel Functions (VLOOKUP, INDEX-MATCH, Pivot Tables)',
                    'Data Cleaning with Power Query',
                    'Financial Modeling & Business Analytics with Excel',
                    'Creating Interactive Dashboards with Excel',
                    'Hands-on Project: Build a Sales Analysis Dashboard in Excel'
                ] 
            },
            { 
                title: 'Week 3: SQL for Data Analytics', 
                topics: [
                    'Writing SQL Queries: Joins, Aggregations, Window Functions',
                    'Data Manipulation: Filtering, Sorting, Grouping',
                    'SQL Case Studies: Customer Segmentation, Sales Trends',
                    'Data Warehousing Basics & Connecting SQL to BI Tools',
                    'Hands-on Project: Analyzing customer behavior using SQL'
                ] 
            },
            { 
                title: 'Week 4: Python for Data Analytics', 
                topics: [
                    'Python Basics for Data Analytics',
                    'Data Handling with Pandas & NumPy',
                    'Exploratory Data Analysis (EDA) with Pandas',
                    'Automating Reports with Python',
                    'Hands-on Project: Automate data cleaning and analysis for a dataset'
                ] 
            },
            { 
                title: '📍 Month 2: Data Visualization & BI Dashboards', 
                topics: [] 
            },
            { 
                title: 'Week 5: Data Storytelling & Visualization Principles', 
                topics: [
                    'Fundamentals of Data Storytelling',
                    'Best Practices in Data Visualization',
                    'Choosing the Right Chart Type (Bar, Pie, Heatmap, etc.)',
                    'Interactive vs. Static Visualizations',
                    'Hands-on Assignment: Create a story-driven data report'
                ] 
            },
            { 
                title: 'Week 6: Power BI for Business Analytics', 
                topics: [
                    'Introduction to Power BI',
                    'Importing Data & Data Transformations',
                    'Building Interactive Dashboards',
                    'DAX Functions for Data Modeling',
                    'Hands-on Project: Create a Power BI dashboard for E-commerce Analytics'
                ] 
            },
            { 
                title: 'Week 7: Tableau for Data Visualization', 
                topics: [
                    'Tableau Basics: Connecting Data & Building Charts',
                    'Advanced Calculations & Parameters',
                    'Storytelling with Tableau Dashboards',
                    'Tableau vs. Power BI vs. Google Data Studio',
                    'Hands-on Project: Build a Tableau Dashboard for HR Analytics'
                ] 
            },
            { 
                title: 'Week 8: AI-Powered Data Analytics', 
                topics: [
                    'Introduction to AI & AutoML for Data Analytics',
                    'Predictive Analytics with AI',
                    'AI-Powered Business Insights (Google AI, AWS AI)',
                    'Automating Data Analysis with GPT & AI Tools',
                    'Hands-on Project: Use AutoML for predictive sales forecasting'
                ] 
            },
            { 
                title: '📍 Month 3: Advanced Analytics & Industry Projects', 
                topics: [] 
            },
            { 
                title: 'Week 9: Google Looker Studio & Marketing Analytics', 
                topics: [
                    'Google Looker Studio (formerly Data Studio)',
                    'Marketing & Web Analytics with Google Analytics',
                    'Google Sheets for Automated Dashboards',
                    'Customer Segmentation & Cohort Analysis',
                    'Hands-on Project: Build a Marketing Analytics Dashboard'
                ] 
            },
            { 
                title: 'Week 10: Big Data Analytics & Cloud BI', 
                topics: [
                    'Introduction to Big Data & Distributed Systems',
                    'Apache Spark for Big Data Analytics',
                    'Cloud Data Warehousing (AWS Redshift, Google BigQuery)',
                    'Real-time Analytics with Kafka & Stream Processing',
                    'Hands-on Project: Analyzing big datasets using Google BigQuery'
                ] 
            },
            { 
                title: 'Week 11: Business Case Studies & Capstone', 
                topics: [
                    'Data-Driven Decision Making in Business',
                    'Case Studies on Finance, Healthcare, Retail Analytics',
                    'Building End-to-End BI Dashboards',
                    'Using AI for Decision Support',
                    'Hands-on Capstone: Full-Scale Business Analytics Dashboard for a Company'
                ] 
            },
            { 
                title: 'Week 12: Resume Building & Job Preparation', 
                topics: [
                    'Resume & LinkedIn Profile Optimization',
                    'Case Study & Interview Prep for Data Analytics Roles',
                    'Mock Interviews & Business Case Presentations',
                    'Freelancing & Gig Economy for Data Analysts'
                ] 
            }
        ],
        skillsCovered: 'Data manipulation, statistical analysis, data visualization, business intelligence, AI-driven analytics, SQL, Python, Excel, Power BI, Tableau, Google Looker Studio',
        toolsCovered: 'Python, R, SQL, Tableau, Power BI, Excel, Google Looker Studio, Google BigQuery, Jupyter Notebooks, AutoML tools',
        certification: 'Training Certification upon successful completion of the course',
        jobOutcomes: [
            '10+ Real-World Projects',
            'Portfolio & Resume Building',
            'Industry-Ready Skills for BI & Analytics',
            'Capstone Project for Job Readiness'
        ],
        targetAudience: [
            'College students preparing for Data Analytics & BI careers',
            'Aspiring Business Analysts, Data Analysts, & Visualization Experts',
            'Professionals looking to upskill in Data Analytics'
        ]
    },
    {
        id: 'aiml10',
        title: 'Deep Learning - Neural Networks and Advanced AI',
        price: '84999',
        originalPrice: '124999',
        level: 'Advanced',
        duration: '8 Months',
        category: 'aiml',
        banner: {
            title: 'Deep Learning',
            subtitle: 'Neural Networks',
            background: 'bg-gradient-to-r from-slate-700 to-gray-800',
            Icon: Network
        },
        description: 'Master deep learning and neural networks to build cutting-edge AI applications and systems.',
        overview: 'Comprehensive deep learning program covering neural network architectures, computer vision, NLP, and advanced AI applications.',
        highlights: [
            'Complete neural network mastery',
            'Convolutional Neural Networks (CNNs)',
            'Recurrent Neural Networks (RNNs)',
            'Generative Adversarial Networks (GANs)',
            'Computer vision applications',
            'Advanced model architectures'
        ],
        curriculum: [
            { 
                title: 'Months 1-2: Deep Learning Foundations', 
                topics: [
                    'Neural Network Fundamentals',
                    'Backpropagation and Optimization',
                    'Regularization Techniques',
                    'Deep Learning Frameworks (TensorFlow, PyTorch)'
                ] 
            },
            { 
                title: 'Months 3-4: Convolutional Networks', 
                topics: [
                    'Convolutional Neural Networks',
                    'Image Classification and Recognition',
                    'Object Detection and Segmentation',
                    'Transfer Learning for Vision'
                ] 
            },
            { 
                title: 'Months 5-6: Sequential Models', 
                topics: [
                    'Recurrent Neural Networks',
                    'LSTM and GRU Networks',
                    'Sequence-to-Sequence Models',
                    'Attention Mechanisms'
                ] 
            },
            { 
                title: 'Months 7-8: Advanced Architectures', 
                topics: [
                    'Generative Adversarial Networks',
                    'Variational Autoencoders',
                    'Transformer Networks',
                    'Deep Learning Capstone Project'
                ] 
            }
        ]
    },
  
  {
    id: 'aiml15',
    title: "Complete Data Science",
    category: 'aiml',
    level: "Beginner to Advanced",
    duration: "12 Weeks",
    banner: {
      title: 'Complete',
      subtitle: 'Data Science',
      background: 'bg-gradient-to-r from-blue-600 to-indigo-700',
      Icon: 'Database'
    },
    description: "Master Data Science from foundations to advanced AI concepts with real-world projects and industry applications.",
    overview: "36 Sessions | 3 Sessions per Week | 2 Hours per Session | Hands-on Projects + Real-World Business Use Cases + AI & Cloud",
    highlights: [
      "Complete Data Science Curriculum",
      "10+ Real-World Projects",
      "AI & Cloud Integration",
      "MLOps & Model Deployment",
      "Resume & Portfolio Building"
    ],
    curriculum: [
      { 
        title: '📍 Month 1: Python, Data Handling & Exploratory Data Analysis (EDA)', 
        topics: [] 
      },
      { 
        title: 'Week 1: Python Foundations for Data Science', 
        topics: [
          'Python Basics: Data Types, Loops, Functions',
          'NumPy for Numerical Computing',
          'Pandas for Data Handling & Processing',
          'Data Cleaning & Feature Engineering',
          'Hands-on Assignment: Preprocessing a messy dataset'
        ] 
      },
      { 
        title: 'Week 2: SQL & Databases for Data Science', 
        topics: [
          'Writing SQL Queries: Joins, Aggregations, Window Functions',
          'NoSQL (MongoDB) for Unstructured Data',
          'Data Warehousing & Data Pipelines',
          'Extracting Data from APIs & Web Scraping',
          'Hands-on Project: Analyzing customer behavior using SQL'
        ] 
      },
      { 
        title: 'Week 3: Data Visualization & Storytelling', 
        topics: [
          'Matplotlib & Seaborn for Exploratory Data Analysis',
          'Power BI & Tableau for Business Intelligence',
          'Google Looker Studio for Web Analytics',
          'AI-Driven Data Storytelling',
          'Hands-on Project: Building an Interactive Business Dashboard'
        ] 
      },
      { 
        title: 'Week 4: Statistics & Probability for Data Science', 
        topics: [
          'Descriptive & Inferential Statistics',
          'Hypothesis Testing & A/B Testing',
          'Probability Distributions',
          'Statistical Insights for Decision Making',
          'Hands-on Project: A/B testing for marketing campaign success'
        ] 
      },
      { 
        title: '📍 Month 2: Machine Learning & AI for Data Science', 
        topics: [] 
      },
      { 
        title: 'Week 5: Introduction to Machine Learning (ML) with Scikit-Learn', 
        topics: [
          'Supervised vs. Unsupervised Learning',
          'Regression Models: Linear, Polynomial',
          'Classification Models: Logistic Regression, Decision Trees',
          'Model Selection & Evaluation Metrics',
          'Hands-on Project: Predicting House Prices using Regression'
        ] 
      },
      { 
        title: 'Week 6: Advanced ML Models & Feature Engineering', 
        topics: [
          'Random Forest, XGBoost, and Ensemble Learning',
          'Feature Selection & Dimensionality Reduction (PCA, LDA)',
          'Hyperparameter Tuning (GridSearchCV, RandomizedSearchCV)',
          'Hands-on Project: Fraud Detection using ML Models'
        ] 
      },
      { 
        title: 'Week 7: Deep Learning with TensorFlow & Keras', 
        topics: [
          'Introduction to Neural Networks',
          'Convolutional Neural Networks (CNNs) for Image Processing',
          'Recurrent Neural Networks (RNNs) for Time Series Data',
          'Transfer Learning & Pre-trained Models',
          'Hands-on Project: Image Classification using CNNs'
        ] 
      },
      { 
        title: 'Week 8: Natural Language Processing (NLP) & LLMs', 
        topics: [
          'Text Processing: Tokenization, Stemming, Lemmatization',
          'Sentiment Analysis using NLP',
          'Transformer-based NLP (BERT, GPT)',
          'AI-powered Chatbots & Text Summarization',
          'Hands-on Project: Customer Sentiment Analysis using NLP'
        ] 
      },
      { 
        title: '📍 Month 3: Advanced Topics, Big Data & MLOps', 
        topics: [] 
      },
      { 
        title: 'Week 9: Big Data Analytics & Cloud Computing', 
        topics: [
          'Introduction to Big Data & Apache Spark',
          'Cloud Data Warehousing (Google BigQuery, AWS Redshift)',
          'Streaming Analytics with Kafka',
          'AI & Data Science on Cloud (AWS, GCP, Azure)',
          'Hands-on Project: Analyzing Big Data with Google BigQuery'
        ] 
      },
      { 
        title: 'Week 10: MLOps & Model Deployment', 
        topics: [
          'Introduction to MLOps',
          'CI/CD Pipelines for Machine Learning',
          'Model Deployment using Flask & FastAPI',
          'Docker & Kubernetes for ML',
          'Hands-on Project: Deploying a Machine Learning Model as an API'
        ] 
      },
      { 
        title: 'Week 11: AI Agents & Automated Data Science', 
        topics: [
          'AI Agents for Data Science (AutoML, AutoGPT)',
          'Reinforcement Learning for AI Analytics',
          'Ethical AI & Responsible Data Science',
          'Automated Data Engineering Pipelines',
          'Hands-on Project: AutoML-powered Predictive Analytics Model'
        ] 
      },
      { 
        title: 'Week 12: Resume Building & Job Preparation', 
        topics: [
          'Data Science Resume & LinkedIn Optimization',
          'Data Science Portfolio Building',
          'Data Science Case Studies & Interviews',
          'Mock Interviews & Business Case Presentations',
          'Final Capstone Project: End-to-End AI-Powered Data Science Solution'
        ] 
      }
    ],
    skillsCovered: 'Python Programming, Data Analysis, Machine Learning, Deep Learning, NLP, Big Data, MLOps, Cloud Computing, AI Agents',
    toolsCovered: 'Python, SQL, MongoDB, Tableau, Power BI, Excel, Google Looker Studio, Scikit-Learn, TensorFlow, Keras, Apache Spark, Docker, Kubernetes',
    certification: 'Training Certification upon successful completion of the course',
    jobOutcomes: [
      '10+ Real-World Projects',
      'Resume & Portfolio Building',
      'AI, MLOps, & Cloud Expertise',
      'Capstone Project for Job Readiness'
    ],
    targetAudience: [
      'College students aiming for Data Science & AI careers',
      'Aspiring Machine Learning Engineers & Data Scientists',
      'Professionals looking to upskill in AI-driven Data Science'
        ]
    }
]; 